<!-- DetailsTopic.vue -->
<script setup lang="ts">
  import { IDefinitionProps } from '@/types'
  import { Typography } from '@components/index'

  const props = defineProps<IDefinitionProps>()
  const emit = defineEmits(['onOpenModal'])

  const handleSpanClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    const dataId = target.getAttribute('data-id')
    if (dataId) {
      const link = props.external_nodes.find(link => link.id === dataId)
      if (link) {
        emit('onOpenModal', link)
      }
    }
  }
</script>

<template>
  <div class="col-12">
    <div class="d-flex align-items-center justify-content-between">
      <Typography variant="regulation-topic">{{ props.title }}</Typography>
      <UTooltip
        v-if="props.tooltip"
        :content="{ side: 'left', align: 'start' }"
        :ui="{
          content: '!block !h-auto bg-[#303338] ounded-md max-w-[20rem] px-3 py-3 me-2 rounded-md'
        }"
      >
        <template #content>
          <Typography variant="tooltip">{{ props.tooltip }}</Typography>
        </template>

        <i class="bi-question-circle-fill" />
      </UTooltip>
    </div>
    <div class="mb-3 pt-2 pb-3 d-flex flex-column align-items-start list-style">
      <Typography variant="regulation-details">
        <div
          @click="handleSpanClick($event)"
          v-html="props.description"
        />
      </Typography>
    </div>
  </div>
</template>

<style>
  .list-style li {
    list-style: disc;
  }
</style>
